<template>
  <div>
    <ag-loading v-if="loading" />
    <div class="ag-hash-xml-detail p-4" v-if="hashDetails && !loading">
      <div class="xml-detail d-flex align-item-center">
        <div class="xml-detail d-flex align-items-start flex-column mr-4">
          <a href="javascript:void(0)" @click="showPretty = !showPretty"
            class="ag-button sm border-0 ag-button_primary ag-button_radius">
            <p class="mb-0">{{ showPretty ? "View Raw" : "View Formatted" }}</p>
          </a>
          <a v-if="hashDetails" href="javascript:void(0)" id="collapse" @click="collapse" class="
              ag-button
              sm
              border-0
              ag-button_secondary ag-button_radius
              ml-2
            ">
            <p class="mb-0" v-if="open">Collapse</p>
            <p class="mb-0" v-if="!open">Expand</p>
          </a>
        </div>
        <div class="json-area" v-if="!showPretty">
          <JsonView :data="hashDetails" :max-depth="4" :open="open" :key="compKey"></JsonView>
        </div>
        <!-- Pretty Version -->
        <div class="json-area" v-else>
          <PrettyView :data="hashDetails" :open="open" ></PrettyView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/store/axiosAgsc";
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import JsonView from "./components/JsonView";
import PrettyView from "./components/PrettyView.vue";

const store = useStore();
export default {
  name: "ag-hashxmldetail",
  data: () => ({
    open: true,
    hashDetails: null,
    compKey: 0,
    loading: true,
    showPretty: false,
  }),
  components: {
    AgLoading,
    JsonView,
    PrettyView
  },
  created() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
  },
  methods: {
    getList() {
      this.loading = true;
      api
        .get("Event/GetEventDetail?eventId=" + this.selectedRow.evenId)
        .then((res) => {
          this.hashDetails = res.data.entityData
          setTimeout(() => {
            this.loading = false;
            ++this.compKey;
          }, 350);
        });
    },
    download() {
      var elem = document.querySelector("#download");
      if (elem) {
        var data =
          "text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(this.scopeXmlDetail));
        elem.setAttribute("href", "data:" + data);
        elem.setAttribute("download", "data.json");
      }
    },
    collapse() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-hash-xml-detail {
  padding: 20px 0;

  #collapse {
    margin-left: 0 !important;
    margin-bottom: 1.5rem;
    padding: 5px 10px;
    display: inline-block;
  }

  .json-area {
    max-width: 80%;
    width: 80%;
  }

  .ag-scopeXmldetail {
    height: 60vh;
    overflow: auto;
  }

  .extra-info {
    margin-top: -48px;

    .download-btn {
      color: #4c8dbb;

      i {
        font-size: 10px;
      }
    }
  }

  span {
    color: #8e8e8e;
  }

  strong {
    color: #8e8e8e;
  }
}

.ag-progress {
  width: 50px !important;
  height: 50px !important;

  .progress-bar {
    border-color: #d15656;
  }
}

.xml-detail {
  .ag-button {
    width: 155px;
    margin-bottom: 20px;
  }
}
</style>
